import { useState, useEffect, useContext } from "react";
import { Activity_log_func } from "../../../api/activity_log/activity_log_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { Button, MenuList, MenuButton, Divider, Text, Body1Strong, Body1, Caption1, FluentProvider, Input, useId, Tooltip, Accordion, AccordionHeader, AccordionItem, AccordionPanel } from "@fluentui/react-components";
import { Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, Info16Filled } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../../components/form-components';
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { GlobalContext } from "../../../hooks/globalContext";
import { ToastComponent } from "../../../components/toast/toast.component";
import { buttonContent, DynamicBoxingCSS, SubSectionResponsive, parentHome, primaryIcon, secondaryIcon, wraperStyle, dashboardTheme, BreadcrumbsBorder, timezoneInfo } from "../../../styles/customStyles";
import { FileDownloadComponent } from "../../../components/fileExport/file.export.component";
import { Automation_activity_log_func } from "../../../api/activity_log/automation_activity_log";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { SecurityPages } from "../../../components/side_menu/InlineSidenav";

export const SecurityModuleActivityLog = () => {
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / '); const dropdownId = useId("dropdown-default");
  const handle = useFullScreenHandle();
  interface FormDailyItem {
    id: number;
    data: {};
  }

  interface FormWeeklyItem {
    id: number;
    data: {};
  }

  interface FormMonthlyDateItem {
    id: number;
    data: {};
  }

  interface FormMonthlyTimeItem {
    id: number;
    data: {};
  }
  interface FormItem {
    id: number;
    data: {};
  }
  interface FormItems {
    id: number;
    data: {};
  }

  const radioData1 = {
    "Execute earliest available opportunity": "1",
    "Execute next available opportunity": "2",
  };

  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const dates = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];


  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [isRefresh, setRefresh] = useState(false);
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [overlayData, setOverlayData] = useState<any>(false);
  const [activityExportData, setActivityExportData] = useState<any>('No data available');
  const [jsonSchema, setJsonData]: any = useState({});
  const [uiSchema, setUiData]: any = useState({});
  const [dartNo, setDartNo] = useState(0);
  const [overLayFormData, setOverLayFormData]: any = useState({
    headerTitle: '',
    tabItems: ''
  });
  const [activity, setActivity]: any = useState('{}');
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [oldSelectedOptions, setOldSelectedOptions] = useState([]);
  const [remediationObj, setRemediationObj] = useState<any>({});
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
  const [errorMessage, setErrorMessage] = useState<String>('')
  const [uniqueModule, setUniqueModule] = useState<string[]>([]);
  const [uniqueAction, setUniqueAction] = useState<string[]>([]);
  const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);

  // Options for each filter category
  const [createdByOptions, setCreatedByOptions] = useState<any[]>([]);
  const [moduleOptions, setModuleOptions] = useState<any[]>([]);
  const [actionOptions, setActionOptions] = useState<any[]>([]);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);

  const [configFormData, setConfigFormData]: any = useState({
    executionTime: []
  });
  const [oldConfigFormData, setOldConfigFormData]: any = useState({
    executionTime: []
  });

  const [cloneDailyForms, setcloneDailyForms] = useState<FormDailyItem[]>([]);
  const [cloneOldDailyForms, setcloneOldDailyForms] = useState<FormDailyItem[]>([]);

  const [clickedDays, setClickedDays] = useState<{ [key: string]: boolean }>(daysOfWeek.reduce((acc, day) => {
    acc = false;
    return acc;
  }, {}));
  const [oldClickedDays, setOldClickedDays] = useState<{ [key: string]: boolean }>(daysOfWeek.reduce((acc, day) => {
    acc = false;
    return acc;
  }, {}));

  const [clickedMonths, setClickedMonths] = useState<{ [key: string]: boolean }>(months.reduce((acc, month) => {
    acc = false;
    return acc;
  }, {}));

  const [cloneWeeklyForms, setCloneWeeklyForms] = useState<FormWeeklyItem[]>([]);

  const [cloneMonthlyFormsDate, setcloneMonthlyFormsDate] = useState<FormMonthlyDateItem[]>([]);

  const [cloneMonthlyFormsTime, setcloneMonthlyFormsTime] = useState<FormMonthlyTimeItem[]>([]);

  const [cloneScore, setCloneScore] = useState<FormItems[]>([{
    id: 1,
    data: {
      answerid: 1,
      alabel: "",
      score: "",
      adesc: ""
    }
  }]);

  const [cloneForms, setCloneForms] = useState<FormItem[]>([{
    id: 1, data: {
      "questionid": 1,
      "qlabel": "",
      "type": "",
      "qdesc": "",
      "answer": [{
        answerid: 1,
        alabel: "",
        score: "",
        adesc: ""
      }]
    }
  }]);

  useEffect(() => {
    setCreatedByOptions(uniqueCreatedBy?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setModuleOptions(uniqueModule?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setActionOptions(uniqueAction?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setStatusOptions(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
}, [uniqueCreatedBy, uniqueModule, uniqueAction, uniqueStatus]);

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1
    const value2 = dropDownValue2;
    // if(value1 !== undefined && value1 !== '' && value2 !== undefined && value2 !== '') {
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
    // }
  }
  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
  }

  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    } else {
      setResetDisabled(true)
    }
  }, [filterArray])

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9 ]*$/;
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
        setErrorMessage(`${dropDownValue1} is already filtered.`);
        return;
    } else {
        setErrorMessage(''); // Clear the message if no issue
    }
    if (name === 'filter' && dropDownValue1 === ("Activity")) {
        if (regexSN.test(enteredValue)) {
            setDropDownValue2(enteredValue);
        }
    }
    if (name === 'filter' && dropDownValue1 === ("Action") || dropDownValue1 === ("Status") || dropDownValue1 === ("Module")) {
        if (regexS.test(enteredValue)) {
            setDropDownValue2(enteredValue);
        }
    }
}

  //data table column name code starts here
  var columns = [
    { key: "date", label: <Body1Strong>&nbsp;&nbsp; Date (UTC) </Body1Strong> },
    { key: "date_timezoned",
      label: <>
        <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
          <StackItem>
            <Body1Strong>&nbsp;&nbsp;Date</Body1Strong>
          </StackItem>
          <StackItem align="center">
            <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
              <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
            </Tooltip>
          </StackItem>
        </Stack>
      </>
    },
    { key: "page", label: <Body1Strong> Module </Body1Strong> },
    // { key: "os", label: <Body1Strong> Scope </Body1Strong> },
    { key: "activity", label: <Body1Strong> Activity </Body1Strong> },
    { key: "initiated_by", label: <Body1Strong> Initiated by </Body1Strong> },
    { key: "action", label: <Body1Strong> Action </Body1Strong> },
    { key: "status", label: <Body1Strong> Status </Body1Strong> },
  ];
  //data table column name code ends here
  //data table for filter
  var columns1 = [
    { key: "date", label: <Caption1> Date </Caption1> },
    { key: "module", label: <Caption1> Module </Caption1> },
    { key: "activity", label: <Caption1> Activity </Caption1> },
    { key: "initiated_by", label: <Caption1> Initiated by </Caption1> },
    { key: "action", label: <Caption1> Action </Caption1> },
    // { key: "", label: <Caption1> Scope </Caption1> },
    // { key: "target", label: <Caption1> Target </Caption1> },
    // { key: "status", label: <Caption1> Status </Caption1> },
  ];

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setRefresh(true); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        {permissions.includes("all") || permissions.includes("automationLog_Fullaccess") || permissions.includes("automationLog_ReadandExport") ?
          <StackItem>
            <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_automation_activitylog.csv`}>
            </CSVLink>
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); }}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                <StackItem> <Caption1> Export </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
          :
          <StackItem>
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem><Text></Text></StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem><Caption1> Export </Caption1></StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          </StackItem>
        }

        {/* <StackItem>
          <Button shape="circular" appearance="subtle" size="small">
            <Stack tokens={{childrenGap:5}} horizontal>
              <StackItem> <Settings20Regular {...primaryIcon}/> </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem> */}

        <StackItem grow shrink>
            <Stack horizontalAlign="end">
                <StackItem grow shrink>
                    <FullScreenButton handle={handle} />
                </StackItem>
            </Stack>
        </StackItem>
      </>
    ,
  };
  // overflow set contents code ends here

  var tempTableData: any = [];
  var menuLists: any = [];

  useEffect(() => {
    var tempExportData: any = [];

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      tempExportData.push({
        'Date': val.time ? convertToExcelFormat(val.time) : "-",
        'Module': val.pageName,
        'Activity': JSON.parse(val?.activity)?.summary,
        "Initiated By": val.initiatedBy,
        'Action': val.action,
        'Status': val.status,
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    console.log("activity?.type=", activity?.type);

    var dartVal = activity?.dartNo;
    dartVal != undefined && setDartNo(dartVal);

    if (activity?.type === 'selfhelp') {
      setRemediationObj({
        type: activity?.type,
        automation_sequence: activity?.configuration?.automation_sequence,
        old_automation_sequence: activity?.old_configuration?.automation_sequence,
      });
    } else if (activity?.type === 'scheduler') {
      var type = activity?.configuration?.type;
      setSelectedOptions(activity?.configuration?.scheduledAutomations);
      setOldSelectedOptions(activity?.old_configuration?.scheduledAutomations);

      var oldTimeArr: any[] = [];
      if (type === 'daily') {
        activity.old_configuration?.executionTime?.map((val: any, i: any) => {
          i == 0 ? oldTimeArr.push({ id: 0, time: val }) : oldTimeArr.push({ id: Date.now(), time: val });
        })
        setOldConfigFormData({
          executionTime: oldTimeArr,
          recommendedAction: activity?.old_configuration.recommendedAction,
          weekend: activity?.old_configuration.weekend
        });
        activity.old_configuration?.executionTime?.map((val: any, i: any) => {
          i != 0 && setcloneOldDailyForms([...cloneOldDailyForms, { id: Date.now(), data: {} }]);
        });

        setClickedDays(daysOfWeek.reduce((acc, day) => {
          acc = false;
          return acc;
        }, {}));

        setClickedMonths(months.reduce((acc, month) => {
          acc = false;
          return acc;
        }, {}));
      } else if (type === 'weekly') {
        activity.old_configuration?.executionTime?.map((val: any, i: any) => {
          i == 0 ? oldTimeArr.push({ id: 0, time: val }) : oldTimeArr.push({ id: Date.now(), time: val });
        })

        setOldConfigFormData({
          executionTime: oldTimeArr,
          recommendedAction: activity.old_configuration.recommendedAction,
          days: activity.old_configuration.days
        });

        activity.old_configuration?.days?.map((val: any, i: any) => {
          setClickedDays((prevClickedDays) => ({
            ...prevClickedDays,
            [`isWeeklyButton${val}Clicked`]: !prevClickedDays[`isWeeklyButton${val}Clicked`],
          }));
        });

        activity.old_configuration?.executionTime?.map((val: any, i: any) => {
          i != 0 && setCloneWeeklyForms([...cloneWeeklyForms, { id: Date.now(), data: {} }]);
        });

        // setcloneDailyForms([]);

        setClickedMonths(months.reduce((acc, month) => {
          acc = false;
          return acc;
        }, {}));
      } else {
        //monthly scheduler
        activity.old_configuration?.executionTime?.map((val: any, i: any) => {
          i == 0 ? oldTimeArr.push({ id: 0, time: val }) : oldTimeArr.push({ id: Date.now(), time: val });
        });

        var dateArr: any = [];
        activity.old_configuration?.date?.map((val: any, i: any) => {
          i == 0 ? dateArr.push({ id: 0, date: val }) : dateArr.push({ id: Date.now(), date: val });
        });

        activity.old_configuration?.months?.map((val: any) => {
          setClickedMonths((prevClickedMonths) => ({
            ...prevClickedMonths,
            [`isMonthButton${val}Clicked`]: !prevClickedMonths[`isMonthButton${val}Clicked`],
          }));
        })

        activity.old_configuration?.date?.map((val: any, i: any) => {
          i !== 0 && setcloneMonthlyFormsDate([...cloneMonthlyFormsDate, { id: Date.now(), data: {} }]);
        })

        //setcloneDailyForms([]);

        setClickedDays(daysOfWeek.reduce((acc, day) => {
          acc = false;
          return acc;
        }, {}));

        setOldConfigFormData({
          executionTime: oldTimeArr,
          recommendedAction: activity?.old_configuration.recommendedAction,
          date: dateArr,
          months: activity?.old_configuration.months
        });
      }

      var timeArr: any[] = [];
      if (type === 'daily') {
        activity.configuration?.executionTime?.map((val: any, i: any) => {
          i == 0 ? timeArr.push({ id: 0, time: val }) : timeArr.push({ id: Date.now(), time: val });
        })
        setConfigFormData({
          executionTime: timeArr,
          recommendedAction: activity?.configuration.recommendedAction,
          weekend: activity?.configuration.weekend
        });
        activity.configuration?.executionTime?.map((val: any, i: any) => {
          i != 0 && setcloneDailyForms([...cloneDailyForms, { id: Date.now(), data: {} }]);
        });

        setClickedDays(daysOfWeek.reduce((acc, day) => {
          acc = false;
          return acc;
        }, {}));

        setClickedMonths(months.reduce((acc, month) => {
          acc = false;
          return acc;
        }, {}));
      } else if (type === 'weekly') {
        activity.configuration?.executionTime?.map((val: any, i: any) => {
          i == 0 ? timeArr.push({ id: 0, time: val }) : timeArr.push({ id: Date.now(), time: val });
        })

        setConfigFormData({
          executionTime: timeArr,
          recommendedAction: activity.configuration.recommendedAction,
          days: activity.configuration.days
        });

        activity.configuration?.days?.map((val: any, i: any) => {
          setClickedDays((prevClickedDays) => ({
            ...prevClickedDays,
            [`isWeeklyButton${val}Clicked`]: !prevClickedDays[`isWeeklyButton${val}Clicked`],
          }));
        });

        activity.configuration?.executionTime?.map((val: any, i: any) => {
          i != 0 && setCloneWeeklyForms([...cloneWeeklyForms, { id: Date.now(), data: {} }]);
        });

        setcloneDailyForms([]);

        setClickedMonths(months.reduce((acc, month) => {
          acc = false;
          return acc;
        }, {}));
      } else {
        //monthly scheduler
        activity.configuration?.executionTime?.map((val: any, i: any) => {
          i == 0 ? timeArr.push({ id: 0, time: val }) : timeArr.push({ id: Date.now(), time: val });
        });

        var dateArr: any = [];
        activity.configuration?.date?.map((val: any, i: any) => {
          i == 0 ? dateArr.push({ id: 0, date: val }) : dateArr.push({ id: Date.now(), date: val });
        });

        activity.configuration?.months?.map((val: any) => {
          setClickedMonths((prevClickedMonths) => ({
            ...prevClickedMonths,
            [`isMonthButton${val}Clicked`]: !prevClickedMonths[`isMonthButton${val}Clicked`],
          }));
        })

        activity.configuration?.date?.map((val: any, i: any) => {
          i !== 0 && setcloneMonthlyFormsDate([...cloneMonthlyFormsDate, { id: Date.now(), data: {} }]);
        })

        setcloneDailyForms([]);

        setClickedDays(daysOfWeek.reduce((acc, day) => {
          acc = false;
          return acc;
        }, {}));

        setConfigFormData({
          executionTime: timeArr,
          recommendedAction: activity?.configuration.recommendedAction,
          date: dateArr,
          months: activity?.configuration.months
        });
      }
    } else if (activity?.type === 'usersurvey') {
      console.log('activity?.configuration?.questions=', activity?.configuration?.questions);

      setCloneForms(activity?.configuration?.questions?.map((val: any, i: any) => { return { 'id': (i + 1), 'data': val } }))
    }
  }, [activity]);

  // useEffect(() => {
  //   //roles and permissions
  //   async function loadRoute() {
  //     console.log("role:-", sessionStorage.getItem('role'))
  //     const role = sessionStorage.getItem('role');

  //     try {
  //       const [routeAllowed, permissions] = await shouldLoadRoute(role);

  //       if (routeAllowed) {
  //         console.log("permission===", permissions);

  //         setPermissions(permissions)
  //       } else {
  //         console.log('Route is not allowed.');
  //       }
  //     } catch (error) {
  //       console.error('Error loading route:', error);
  //     }
  //   }

  //   loadRoute();
  // }, []);
  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
        const newUniqueCreatedBy: string[] = [];
        const newUniqueModule: string[] = [];
        const newUniqueAction: string[] = [];
        const newUniqueStatus: string[] = [];

        final_data.forEach((val: any) => {
            if (val.initiatedBy && val.initiatedBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.initiatedBy)) {
                newUniqueCreatedBy.push(val.initiatedBy);
            }
            if (val.pageName && val.pageName.trim() !== "-" && !newUniqueModule.includes(val.pageName)) {
                newUniqueModule.push(val.pageName);
            }
            if (val.action && val.action.trim() !== "-" && !newUniqueAction.includes(val.action)) {
                newUniqueAction.push(val.action);
            }
            if (val.status && val.status.trim() !== "-" && !newUniqueStatus.includes(val.status)) {
                newUniqueStatus.push(val.status);
            }
        });
        // Set the unique values for each filter category
        setUniqueCreatedBy(newUniqueCreatedBy);
        setUniqueModule(newUniqueModule);
        setUniqueAction(newUniqueAction);
        setUniqueStatus(newUniqueStatus);
    } else {
        setUniqueCreatedBy([]);
        setUniqueModule([]);
        setUniqueAction([]);
        setUniqueStatus([]);

    }
}, [final_data]);

  useEffect(() => {
    final_data !== undefined && final_data !== null
      ? final_data.map((val: any, i: any) => {
        var activityVal = JSON.parse(val.activity).summary;
        {
          permissions.includes("all") || permissions.includes("automationLog_ReadandExport") ?

            tempTableData.push({
              id: val.ID,
              checkbox: "hide",
              date: { label: <Button style={buttonContent} appearance="transparent" size="small" id="ButtonHover" onClick={() => { setOverlayOpen(true); setOverlayData(val); setActivity(JSON.parse(val.activity)); }}> {convertUTCToReadableFormat(val.time)} </Button>, icon: "", id: `${i}` },
              date_timezoned: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => { setOverlayOpen(true); setOverlayData(val); setActivity(JSON.parse(val.activity)); }}> {convertToLocalTimezone(val.time, userTimeZone)} </Button>, icon: "", id: `${i}` },
              page: { label: <Caption1> {val.pageName} </Caption1>, status: "" },
              activity: { label: <Caption1> {activityVal} </Caption1> },
              initiated_by: { label: <Caption1> {val.initiatedBy} </Caption1> },
              action: { label: <Caption1> {val.action} </Caption1> },
              status: { label: <Caption1> {val.status} </Caption1> },
            })
            :
            tempTableData.push({
              id: val.ID,
              checkbox: "hide",
              date: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => { setOverlayOpen(true); setOverlayData(val); setActivity(JSON.parse(val.activity)); }}> {convertUTCToReadableFormat(val.time)} </Button>, icon: "", id: `${i}` },
              date_timezoned: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => { setOverlayOpen(true); setOverlayData(val); setActivity(JSON.parse(val.activity)); }}> {convertToLocalTimezone(val.time, userTimeZone)} </Button>, icon: "", id: `${i}` },
              page: { label: <Caption1> {val.pageName} </Caption1>, status: "" },
              activity: { label: <Caption1> {activityVal} </Caption1> },
              initiated_by: { label: <Caption1> {val.initiatedBy} </Caption1> },
              action: { label: <Caption1> {val.action} </Caption1> },
              status: { label: <Caption1> {val.status} </Caption1> },
            })
        }
      }) : (tempTableData = []);
    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);

      if (isRefresh) {
        setRefresh(false);
        setRefreshToast(true);
        setTimeout(() => {
          setRefreshToast(false);
        }, 3000);
      }
    }, 500);
  }, [final_data, permissions]);
  // data table values append code ends here

  useEffect(() => {
    var data = '';

    data = `Activity
            \nDate and time of activity - ${overlayData?.time ? new Date(overlayData?.time * 1000).toLocaleString() : ''}
            \nModule where the activity was performed - ${overlayData?.pageName}
            \nActivity - ${activity?.summary}
            \nInitiated by - ${overlayData?.initiatedBy}
            \nAction - ${overlayData?.action}
            \nStatus - ${overlayData?.status}`;

    if (overlayData?.pageName === "Automation") {
      if (overlayData?.action === 'Add' || overlayData?.action === 'Edit') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified properties
                \nAutomation name - ${activity.automation_name}
                \nAutomation type - ${activity.type}`;
      } else if (overlayData?.action === 'Export' || overlayData?.action === 'Delete') {
        data += `\n----------------------------------------
        \nTarget
        \nNot applicalble`;

        data += `\n----------------------------------------
        \nModified properties
        \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Selfhelp") {
      if (overlayData?.action === 'Add' || overlayData?.action === 'Edit') {
        data += `\n----------------------------------------
                \nTarget
                \nClassification name - ${activity.automation_name}
                \nOperation type - ${activity.type}`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      } else if (overlayData?.action === 'Delete' || overlayData?.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Autoheal") {
      if (overlayData?.action === 'Add' || overlayData.action === 'Edit') {
        data += `\n----------------------------------------\nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------\Modified Properties
                \nClassification name - ${activity.automation_name}
                \nOperation type - ${activity.type}`;
      } else if (overlayData?.action === "Export" || overlayData?.action === "Delete") {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Scheduler") {
      if (overlayData.action === 'Edit' || overlayData.action === 'Add') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nClassification name - ${activity.automation_name}
                \nOperation type - ${activity.type}`;
      } else if (overlayData?.action === "Export" || overlayData?.action === "Delete") {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "User Survey") {
      if (overlayData.action === 'Edit' || overlayData.action === 'Add') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nClassification name - ${activity.automation_name}
                \nOperation type - ${activity.type}`;
      } else {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    }

    setActivityExportData(data);
  }, [overlayData]);

  //overlay code starts here
  useEffect(() => {
    var targetItemVal: JSX.Element | String = '';
    var modifiedPropertyVal: JSX.Element | String = '';

    if (overlayData?.pageName === "Data Collection") {
      if (overlayData?.action === 'Delete' || overlayData?.action === 'Export') {
        targetItemVal = <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            <StackItem>
              Not applicalble
            </StackItem>
          </Stack>
        </FluentProvider>

        modifiedPropertyVal = <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            <StackItem>
              Not applicalble
            </StackItem>
          </Stack>
        </FluentProvider>
      } else if (overlayData?.action === 'Add' || overlayData?.action === 'Edit') {
        targetItemVal = <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            <StackItem>
              Not applicalble
            </StackItem>
          </Stack>
        </FluentProvider>

        modifiedPropertyVal = <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            <StackItem>
              <Body1Strong> Automation name </Body1Strong> - <Caption1> {activity.automation_name} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Automation type </Body1Strong> - <Caption1> {activity.type} </Caption1>
            </StackItem>

            <StackItem>
              {activity?.old_configuration != undefined && <><Body1Strong>Old Configuration</Body1Strong>

                {/* {activity?.old_configuration != undefined && <Form formData={JSON.parse(activity?.old_configuration)} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />} */}

                <Accordion collapsible>
                  <AccordionItem value="1">
                    <AccordionHeader>{activity.old_automation_name}</AccordionHeader>

                    <AccordionPanel>
                      <Form formData={activity?.old_configuration} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion></>}
            </StackItem>

            <StackItem>
              {activity?.configuration != undefined && <><Body1Strong>New Configuration</Body1Strong>

                {/* {activity?.configuration != undefined && <Form formData={JSON.parse(activity?.configuration)} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />} */}

                <Accordion collapsible>
                  <AccordionItem value="1">
                    <AccordionHeader>{activity.automation_name}</AccordionHeader>

                    <AccordionPanel>
                      <Form formData={activity?.configuration} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion></>}
            </StackItem>

            <StackItem>

            </StackItem>
          </Stack>
        </FluentProvider>
      }
    } else if (overlayData?.pageName === "Policy") {
      if (overlayData?.action === 'Delete' || overlayData?.action === 'Export') {
        targetItemVal = <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            <StackItem>
              Not applicalble
            </StackItem>
          </Stack>
        </FluentProvider>

        modifiedPropertyVal = <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            <StackItem>
              Not applicalble
            </StackItem>
          </Stack>
        </FluentProvider>
      } else if (overlayData?.action === 'Add' || overlayData?.action === 'Edit') {
        targetItemVal = <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            <StackItem>
              Not applicalble
            </StackItem>
          </Stack>
        </FluentProvider>

        modifiedPropertyVal = <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>

            <StackItem>
              <Body1Strong> Automation name </Body1Strong> - <Caption1> {activity.automation_name} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Automation type </Body1Strong> - <Caption1> {activity.type} </Caption1>
            </StackItem>

            {activity?.old_configuration != undefined && <StackItem>
              <Accordion collapsible>
                <AccordionItem value="1">
                  <Body1Strong>Old Configuration</Body1Strong>
                  <AccordionHeader>{activity.old_automation_name}</AccordionHeader>
                  <AccordionPanel>

                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </StackItem>}

            {activity?.configuration != undefined && <StackItem>
              <Accordion collapsible>
                <AccordionItem value="1">
                  <Body1Strong>New Configuration</Body1Strong>
                  <AccordionHeader>{activity.automation_name}</AccordionHeader>
                  <AccordionPanel>

                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </StackItem>}
          </Stack>
        </FluentProvider>
      }
    }

    console.log("modifiedPropertyVal=", modifiedPropertyVal);

    setOverLayFormData({
      headerTitle:
        (
          <>
            <Stack>
              <Text size={600} weight="semibold"> Audit Log Details </Text>
            </Stack>
          </>
        ),
      size: "large",
      isTabs: true,
      tabItems: {
        Activity:
          <FluentProvider theme={dashboardTheme}>
            <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
              <StackItem>
                <Body1Strong> Date and time of activity (UTC) </Body1Strong> - <Caption1> {overlayData?.time ? new Date(overlayData?.time * 1000).toLocaleString() : ''} </Caption1>
              </StackItem>

              <StackItem>
                <Body1Strong> Module where the activity was performed  </Body1Strong> - <Caption1>{overlayData?.pageName}</Caption1>
              </StackItem>

              <StackItem>
                <Body1Strong> Activity </Body1Strong> - <Caption1>{activity?.summary}</Caption1>
              </StackItem>

              <StackItem>
                <Body1Strong> Initiated By </Body1Strong> - <Caption1>{overlayData?.initiatedBy}</Caption1>
              </StackItem>

              <StackItem>
                <Body1Strong> Action </Body1Strong> - <Caption1>{overlayData?.action}</Caption1>
              </StackItem>

              <StackItem>
                <Body1Strong> Status </Body1Strong> - <Caption1>{overlayData?.status}</Caption1>
              </StackItem>

            </Stack>
          </FluentProvider>,
        Targets: targetItemVal,
        "Modified Properties": modifiedPropertyVal
      },
      footerData:
        (
          <>
            <FileDownloadComponent data={activityExportData} fileName="Activity_log" />
          </>
        )
    });
  }, [overlayData, activity, jsonSchema, selectedOptions, oldSelectedOptions, cloneForms]);

  useEffect(() => {
    const props: any = {
      dartNo: dartNo,
      setDartNo: setDartNo,
      remediationObj: remediationObj,
      setJsonData: setJsonData,
      setUiData: setUiData,
      setSelectedOptions: setSelectedOptions,
      setOldSelectedOptions: setOldSelectedOptions
    }

    Automation_activity_log_func(props);
  }, [dartNo, remediationObj]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
											{name: "Automate", link: "/home" },
                      {name:"Security", link:"/automate/security/compliancepolicy"},
                      {name:"Activity log", link:"#"}
                    ]}
                  />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>
              {/* <Stack tokens={{ childrenGap: 25 }} horizontal>
                <StackItem> <Text></Text> </StackItem>
                <StackItem>
                  <FluentProvider theme={dashboardTheme}>
                    <Title3> Automation | Activity Log </Title3>
                  </FluentProvider>
                </StackItem>
              </Stack> */}
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal>
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={SecurityPages("Activity Log")} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem style={wraperStyle}>
                        <StackItem>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                              <StackItem>
                              <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Module"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                              </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn=
                                  {
                                    <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                        <Body1> Filter </Body1>
                                      </Stack>
                                    </MenuButton>
                                  } itemVal={
                                    <>
                                      <Body1Strong> Add a Filter </Body1Strong>
                                      <Divider />
                                      <MenuList>
                                        <Stack tokens={{ childrenGap: 5 }}>
                                          <StackItem> <Text></Text> </StackItem>
                                          <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                          <DropdownComponent optionData={columns1} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                          <StackItem> <Divider /> </StackItem>
                                          <StackItem> <Caption1> Value </Caption1> </StackItem>
                                          {(dropDownValue1 === 'Date') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                          {dropDownValue1 === "Activity" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />))}
                                          {dropDownValue1 === "Initiated by" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={createdByOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                          {dropDownValue1 === "Module" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={moduleOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                          {dropDownValue1 === "Action" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={actionOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                          {dropDownValue1 === "Status" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={statusOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                        <StackItem> <Divider /> </StackItem>
                                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                                            <StackItem>
                                              <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                <Caption1> Apply </Caption1>
                                              </Button>
                                            </StackItem>

                                            <StackItem>
                                              <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                <Caption1> Cancel </Caption1>
                                              </Button>
                                            </StackItem>
                                          </Stack>
                                        </Stack>
                                      </MenuList>
                                    </>
                                  }
                                />
                              </StackItem>
                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>
                          <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                            <StackItem>
                              {filterArray.length > 0 &&
                                // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                <Stack wrap horizontal >
                                  {filterArray.length > 0 && filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                  {/* </Stack> */}
                                </Stack>}
                            </StackItem>

                            <StackItem disableShrink>
                              {(tableData.length > 0 && !loading) && (
                                totalRecords > 0 &&
                                <Caption1>
                                  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                </Caption1>
                              )}
                            </StackItem>
                          </Stack>
                        </StackItem>
                        {/* <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack> */}
                        <InfoBar showSpaces={true} title={"Activity logs for all modules under Automations are captured in this section, providing a complete history of actions for tracking and auditing."} />
                      </StackItem>

                      <Activity_log_func data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} type="getLog" moduleName="Security" setExportDetails={setExportDetails} setRefresh={setRefresh} isRefresh={isRefresh} setRefreshToast={setRefreshToast} pageName={undefined} page={""} exportBtnClicked={exportBtnClicked} setExportBtnClicked={setExportBtnClicked} filterArray={filterArray} />

                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}

                      {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Activity Log Refreshed'} footer="" />}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay
              overlayopen={overlayOpen}
              setOverlayOpen={setOverlayOpen}
              overlayData={overLayFormData} />
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};